import { t } from '../../../common/i18n.js'
import { Language } from '../../../common/types/i18n.js'
import { getLevelProgressPercent, getPrevThreshold } from '../../../common/utils/level-utils.js'
import './level-progress.css'

export interface LevelProgressProps {
    score: number
    level: number
    nextThreshold: number
    claimedBadgesCount: number
    totalBadgesCount: number
    lang: Language
    subtitle?: string
}

export const LevelProgress = ({
    score,
    level,
    nextThreshold,
    claimedBadgesCount,
    totalBadgesCount,
    lang,
    subtitle,
}: LevelProgressProps) => {
    const lp = t.playtime.levelProgress

    // Calculate progress towards next level using Fibonacci (matching Laravel)
    const prevThreshold = getPrevThreshold(nextThreshold)
    const clampedProgress = getLevelProgressPercent(score, nextThreshold)

    return (
        <div className="level-progress">
            {subtitle && <div className="level-progress__subtitle">{subtitle}</div>}
            <div className="level-progress__info">
                <div className="level-progress__stat">
                    <span className="level-progress__stat-value">{level}</span>
                    <span className="level-progress__stat-label">{lp.level(lang)}</span>
                </div>
                <div className="level-progress__stat">
                    <span className="level-progress__stat-value">{score}</span>
                    <span className="level-progress__stat-label">{lp.score(lang)}</span>
                </div>
                <div className="level-progress__stat">
                    <span className="level-progress__stat-value">
                        {claimedBadgesCount}/{totalBadgesCount}
                    </span>
                    <span className="level-progress__stat-label">{lp.badges(lang)}</span>
                </div>
            </div>
            <div className="level-progress__bar-wrapper">
                <div className="level-progress__bar">
                    <div
                        className="level-progress__bar-fill"
                        style={{ width: `${clampedProgress}%` }}
                    />
                </div>
                <div className="level-progress__thresholds">
                    <span>{prevThreshold}</span>
                    <span>{nextThreshold}</span>
                </div>
            </div>
        </div>
    )
}
